<template>
    <v-card max-width="620px" outlined>
        <div class="primary white--text pa-4">
            <div class="title font-weight-light">PDA and Awards</div>
            <div class="body-2 font-weight-light d-flex align-center" style="opacity:.6">
                <v-icon size="12" color="white" class="mr-2">fa-exclamation-triangle</v-icon>
                <div>Area not visible for students.</div>
            </div>
        </div>

        <div class="pa-4">
            <!-- PDA -->
            <div>
                <div class="title primary--text">PDA</div>
                <div class="body-2">
                    <span v-if="!item.pda">Upload the PDA for</span>
                    <span v-if="item.pda">The PDA for</span>
                    <span class="ml-1">{{item.name}}:</span>
                </div>
                <v-btn depressed class="accent mt-2" @click="showDiagPDA=true">
                    <v-icon small left>fa-cloud-upload-alt</v-icon>
                    <span v-if="!item.pda">Upload file</span>
                    <span v-else>Update file</span>
                </v-btn>
                <!-- <v-btn depressed class="mt-2 ml-3" :color="item.color" v-if="item.pda" target="_blank" :href="item.pda">
                    <v-icon small left>fa-cloud-download-alt</v-icon>
                    Download PDA
                </v-btn> -->
            </div>

            <v-divider class="mt-6 mb-2"></v-divider>
            
            <!-- Awards -->
            <div>
                <div class="title primary--text">Awards</div>
                <div class="body-2">Set the awards earned by {{item.name}}:</div>
                <v-row class="mt-4">
                    <v-col cols="12" sm="6" v-for="(it, index) in awList" :key="it.id">
                        <div class="d-flex align-center">
                            <v-checkbox v-model="awList[index].active" class="mt-n2" hide-details></v-checkbox>
                            <div class="ml-1">
                                <v-img :src="require('@/assets/awards/' + it.id + '.png')" contain width="30px"></v-img>
                            </div>
                            <div class="ml-3 body-2">{{it.title}}</div>
                        </div>
                    </v-col>
                </v-row>
                <div class="text-center my-6">
                    <v-btn depressed class="accent" @click="prepare">Save awards</v-btn>
                </div>
            </div>
        </div>

        <DiagPDA 
        :model="showDiagPDA"
        :item="item"
        @cancel="showDiagPDA=false"
        @close="reinit"/>
    </v-card>
</template>

<script>
import Users from '@/firebase/users'
import DiagPDA from '@/components/core/dialogs/DiagPDA'

export default {
    data: () => ({
        awList: [
            {
                title: 'Top Prospect',
                id: 'topProspect',
                active: false
            },
            {
                title: 'Creativity Challenge Champion',
                id: 'champCreativity',
                active: false
            },
            {
                title: 'Communication Challenge Champion',
                id: 'champCommunication',
                active: false
            },
            {
                title: 'Entrepreneurship Challenge Champion',
                id: 'champEntrepreneurship',
                active: false
            },
            {
                title: 'Communication Badge',
                id: 'badgeCommunication',
                active: false
            },
            {
                title: 'Creativity Badge',
                id: 'badgeCreativity',
                active: false
            },
            {
                title: 'Energy Badge',
                id: 'badgeEnergy',
                active: false
            },
            {
                title: 'Collaboration Badge',
                id: 'badgeCollaboration',
                active: false
            },
            {
                title: 'Entrepreneurship Badge',
                id: 'bagdeEntrepreneurship',
                active: false
            },
            {
                title: 'Leadership Badge',
                id: 'badgeLeadership',
                active: false
            },
            {
                title: 'Problem Solver',
                id: 'problemSolver',
                active: false
            },
            {
                title: 'Best Life Map',
                id: 'bestLifeMap',
                active: false
            },
            {
                title: 'Linkedin Master',
                id: 'linkedin',
                active: false
            },
            {
                title: 'Circle of Ridicule Champion',
                id: 'circleRidicule',
                active: false
            },
            {
                title: 'The Advertsity Master',
                id: 'adversityMaster',
                active: false
            }
        ],
        earned: [],
        showDiagPDA: false
    }),
    components: {
        DiagPDA
    },
    props: ['item'],
    mounted() {
        this.init();
    },
    methods: {
        reinit() {
            this.$emit('pdasaved');
            this.$store.dispatch('setSnack', {kind:'success', text:'PDA saved.'});
        },
        init() {
            this.getEarned();
            this.setAwardsEarned();
        },
        getEarned() {
            for(let key in this.item.awards) {
                this.earned.push(key)
            }
        },
        setAwardsEarned() {
            this.awList.forEach(dt => {
                let tempo = this.earned.find(item => {return item == dt.id})
                if (tempo != undefined) {
                    dt.active = true;
                }
            });
        },
        prepare() {
            let tempo = {};

            this.awList.forEach(dt => {
                if (dt.active === true) {
                    tempo[dt.id] = true;
                }
            });

            this.save(tempo);
        },
        save(newAwards) {
            Users.setAwards(this.item.uid, newAwards)
                .then(response => {
                    if (response === true) {
                        this.$emit('awardssaved');
                        this.$store.dispatch('setSnack', {kind:'success', text:'Awards saved.'});
                    } else {
                        this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                    }
                })
        }
    }
}
</script>

<style scoped>
    a {
        color: white !important;
    }
</style>